import { useImagePanZoom } from './useImagePanZoom'

interface DocumentImageStageProps {
    src: string
    alt: string
    zoom: number
    /** Clockwise, in quarter turns (0 / 90 / 180 / 270). */
    rotation: number
    onZoomChange: (zoom: number) => void
    /** The browser could not decode the image (corrupt file, unsupported type, revoked blob). */
    onError: () => void
}

/** An image centred in its frame that can be wheel-zoomed, dragged when it overflows, and rotated. */
export const DocumentImageStage = ({ src, alt, zoom, rotation, onZoomChange, onError }: DocumentImageStageProps) => {
    const { frameRef, frameHandlers, imageStyle, onImageLoad, cursor } = useImagePanZoom({ zoom, rotation, onZoomChange })

    return (
        <div ref={frameRef} className={`relative h-full w-full touch-none select-none overflow-hidden ${cursor}`} {...frameHandlers}>
            <img
                src={src}
                alt={alt}
                draggable={false}
                onLoad={onImageLoad}
                onError={onError}
                style={imageStyle}
                className={`absolute left-1/2 top-1/2 ${imageStyle.width === undefined ? 'max-h-full max-w-full object-contain' : 'max-w-none'}`}
            />
        </div>
    )
}
